import ArticlePageComponent from '../components/BlogSection/ArticleSection/ArticlePageComponent';
import BlogLayout from '../components/BlogLayout/BlogLayout';

const ArticlePage = ({ hideHeaderFooter, hideLanguageSwitcher, hideHeaderFooterSetter }) => {
  return (
    <BlogLayout 
      hideHeaderFooter={hideHeaderFooter} 
      hideLanguageSwitcher={hideLanguageSwitcher}
    >
      <ArticlePageComponent hideHeaderFooter={hideHeaderFooter} hideHeaderFooterSetter={hideHeaderFooterSetter}/>
    </BlogLayout>
  );
};

export default ArticlePage;